export enum TypeOptions {
	TIME = 'TIME',
	EXPENSE = 'EXPENSE'
}

export enum ClassOptions {
	billable = 'billable',
	nonBillable = 'non-billable',
	administrative = 'administrative'
}

export enum RateOptions {
	NORATE = 'NORATE',
	STAFF = 'STAFF',
	FIXED = 'FIXED'
}

export enum SurchargeMethods {
	NOSURCHARGE = 'NOSURCHARGE',
	FIXEDAMOUNT = 'FIXEDAMOUNT',
	PERUNIT = 'PERUNIT',
	HOURLY = 'HOURLY',
	PERCENT = 'PERCENT'
}
